'use client';

import dynamic from 'next/dynamic';
import { useIsMobile } from '@/hooks/useIsMobile';
import type { ProcessStep } from '@jlg-website/database/types';
import type { ProcessStepsCarouselProps } from './type';

const ProcessStepsCarouselDesktop = dynamic(() => import('./desktop'), {
  loading: () => <div></div>,
});
const ProcessStepsCarouselMobile = dynamic(() => import('./mobile'), {
  loading: () => <div></div>,
});

export function ProcessStepsCarousel({ steps, title }: ProcessStepsCarouselProps) {
  const mobile = useIsMobile();
  let data: ProcessStep | null = null;
  if (steps) {
    const content = steps.content as { metadata: unknown; data: { position: number }[] };
    const sortedItems = [...content.data].sort((a, b) => (a.position < b.position ? -1 : 1));
    data = {
      ...steps,
      content: { metadata: content.metadata, data: sortedItems },
    } as unknown as ProcessStep;
  }

  if (!data) return;

  return (
    <div className="w-full max-w-page mx-auto">
      {mobile ? (
        <ProcessStepsCarouselMobile steps={data} title={title} />
      ) : (
        <ProcessStepsCarouselDesktop steps={data} title={title} />
      )}
    </div>
  );
}

export default ProcessStepsCarousel;
